import { createStore } from 'vuex';

import visitsModule from './modules/visits';
import authModule from './modules/auth';
import customersModule from './modules/customers';
import productsModule from './modules/products';
import inventoryModule from './modules/inventory';
import variousModule from './modules/various';

const store = createStore({
    modules: {
        visits: visitsModule,
        auth: authModule,
        customers: customersModule,
        products: productsModule,
        inventory: inventoryModule,
        various: variousModule
    }
});

export default store;
